import { gql } from '@apollo/client'

export default gql`
  mutation suggestQuestion($text: String!) {
    suggestQuestion(text: $text) {
      text
    }
  }
`
